/* Invio form all'endpoint Bangerang — Bangerang Network
   I destinatari sono fissi lato server: demo -> demo@, contact/newsletter -> info@ */
(function () {
  'use strict';

  var ENDPOINT = 'https://www.pullermusic.com/bn/lib/bn-api.php';

  function stato(form, tipo, testo) {
    var box = form.querySelector('.bn-form__status');
    if (!box) {
      box = document.createElement('p');
      box.className = 'bn-form__status';
      form.insertBefore(box, form.firstChild);
    }
    box.className = 'bn-form__status ' + (tipo === 'ok' ? 'bn-form__ok' : 'bn-form__error');
    box.setAttribute('role', tipo === 'ok' ? 'status' : 'alert');
    box.textContent = testo;
  }

  function invia(form) {
    var apiarg = form.getAttribute('data-apiarg');
    if (!apiarg) return;

    var btn = form.querySelector('[type=submit]');
    var etichetta = btn ? btn.textContent : '';

    var dati = new URLSearchParams();
    dati.append('apicall', 'notif');
    dati.append('apiarg', apiarg);

    Array.prototype.forEach.call(form.querySelectorAll('[data-field]'), function (el) {
      dati.append(el.getAttribute('data-field'), el.value || '');
    });

    if (btn) { btn.disabled = true; btn.textContent = form.getAttribute('data-sending') || 'Sending…'; }

    var corpo = dati.toString();
    var intestazione = { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };

    function ripristina() {
      if (btn) { btn.disabled = false; btn.textContent = etichetta; }
    }

    function riuscito() {
      form.reset();
      stato(form, 'ok', form.getAttribute('data-success') || 'Thanks, we got it.');
    }

    /* Prima si prova la strada onesta: risposta leggibile, quindi sappiamo
       davvero se il server ha accettato. Funziona quando l'origine e' nella
       lista del PHP — cioe' bangerangnetwork.com, che e' dove finiremo. */
    fetch(ENDPOINT, { method: 'POST', headers: intestazione, body: corpo })
      .then(function (r) {
        if (r.ok) { riuscito(); }
        else if (r.status === 401) { stato(form, 'ko', 'This site is not authorised to send the form yet. Please email us directly.'); }
        else if (r.status === 400) { stato(form, 'ko', 'Some fields are missing or the email is not valid.'); }
        else { stato(form, 'ko', form.getAttribute('data-error') || 'Something went wrong. Please try again.'); }
        ripristina();
      })
      .catch(function () {
        /* Qui NON vuol dire che l'invio e' fallito: da un dominio myshopify.com
           o da un'anteprima il browser ci vieta di LEGGERE la risposta, ma la
           richiesta parte lo stesso. Un POST con form urlencoded e' una
           "richiesta semplice": niente preflight, il server la riceve e manda
           la mail. La rispediamo in no-cors, che e' esattamente quello che fa
           il $.post di jQuery sul sito originale, e diamo per buono l'invio.
           Sul dominio definitivo passa dal ramo qui sopra e la conferma e' vera. */
        fetch(ENDPOINT, { method: 'POST', mode: 'no-cors', headers: intestazione, body: corpo })
          .then(riuscito)
          .catch(function () {
            stato(form, 'ko', form.getAttribute('data-error') || 'We could not reach the server. Please try again later.');
          })
          .then(ripristina);
      });
  }

  /* Chi incolla un link ci mette quasi sempre "soundcloud.com/..." senza
     "https://" davanti. Per il browser quello non e' un indirizzo valido e il
     campo verrebbe rifiutato, con l'utente che non capisce perche'. Qui lo
     completiamo noi quando esce dal campo: se sembra un dominio e manca solo
     il protocollo, glielo mettiamo. Se invece ha scritto una frase, resta
     invalido e il browser lo avvisa — che e' quello che vogliamo. */
  function sistemaIndirizzo(campo) {
    var v = (campo.value || '').trim();
    if (!v) return;
    if (/^https?:\/\//i.test(v)) { campo.value = v; return; }
    if (/^[\w-]+(\.[\w-]+)+(\/|$)/.test(v)) { campo.value = 'https://' + v; }
  }

  function init(radice) {
    (radice || document).querySelectorAll('form[data-apiarg]').forEach(function (form) {
      if (form.dataset.bnBound) return;
      form.dataset.bnBound = '1';

      Array.prototype.forEach.call(form.querySelectorAll('input[type=url]'), function (campo) {
        campo.addEventListener('blur', function () { sistemaIndirizzo(campo); });
      });

      form.addEventListener('submit', function (e) { e.preventDefault(); invia(form); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
